// extracted by mini-css-extract-plugin
module.exports = {"error":"FormTextInputError_error_2PxiD","errorIcon":"FormTextInputError_errorIcon_38UqH","errorText":"FormTextInputError_errorText_3TpWv"};